import { Alert, Snackbar } from '@mui/material'
import { RootState } from '../store'
import { useDispatch, useSelector } from 'react-redux'
import { showError } from '../actions/organization'

const DisplayErrorPopup = () => {
  const dispatch = useDispatch<any>()
  const error = useSelector(
    (state: RootState) => state.organization.errorMessage,
  )
  const showErrorPopup = useSelector(
    (state: RootState) => state.organization.showErrorPopup,
  )

  const handleCloseSnackbar = () => {
    dispatch(showError(false))
  }

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={showErrorPopup}
      autoHideDuration={3500}
      onClose={handleCloseSnackbar}
    >
      <Alert variant='filled' severity='error'>
        {error}
      </Alert>
    </Snackbar>
  )
}

export default DisplayErrorPopup
